import React, { useRef, useState } from "react";
import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

function ContactUsForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const ContactSchema = Yup.object().shape({
    Name: Yup.string()
      .min(2, "Too Short!")
      .max(70, "Too Long!")
      .required("This Field is Required"),
    Email: Yup.string()
      .email("Invalid email")
      .required("This Field is Required"),
    Mobile: Yup.string()
      .min(2, "Too Short!")
      .max(70, "Too Long!")
      .required("This Field is Required"),
    selected_option: Yup.string().required("This Field is Required"),
    picked: Yup.string().required("Please choose Rental or Decor"),
    // Conditional validations based on selected radio button

    Rental_Date: Yup.string().when("picked", {
      is: (val) => val === "Rental",
      then: () => Yup.string().required("Rental Date is required"),
    }),
    Duration: Yup.string().when("picked", {
      is: (val) => val === "Rental",
      then: () => Yup.string().required("Duration is required"),
    }),
    product_renting: Yup.string().when("picked", {
      is: (val) => val === "Rental",
      then: () => Yup.string().required("Product information is required"),
    }),
    Rental_Message: Yup.string().when("picked", {
      is: (val) => val === "Rental",
      then: () => Yup.string().required("Message is required"),
    }),
    Decor_Date: Yup.string().when("picked", {
      is: (val) => val === "Decor",
      then: () => Yup.string().required("Event Date is required"),
    }),
    Event_Location: Yup.string().when("picked", {
      is: (val) => val === "Decor",
      then: () => Yup.string().required("Event Location is required"),
    }),
    budget_range: Yup.string().when("picked", {
      is: (val) => val === "Decor",
      then: () => Yup.string().required("Budget Range is required"),
    }),
    selected_decortype: Yup.array().when("picked", {
      is: (val) => val === "Decor",
      then: () => Yup.array().min(1, "Please select at least one decor type"),
    }),
    Decor_Message: Yup.string().when("picked", {
      is: (val) => val === "Decor",
      then: () => Yup.string().required("Message is required"),
    }),
  });

  const handleValidSubmit = (values, resetForm) => {
    console.log(values);
    setIsSubmitting(true);
    setSuccessMessage("");
    setErrorMessage("");
    const body = {
      Name: values.Name,
      Email: values.Email,
      Mobile: values.Mobile,
      selected_option: values.selected_option,
      picked: values.picked,
      // Rental fields
      Rental_Date: values.Rental_Date || null,
      Duration: values.Duration || null,
      product_renting: values.product_renting || null,
      Rental_Message: values.Rental_Message || null,
      // Decor fields
      Decor_Date: values.Decor_Date || null,
      Event_Location: values.Event_Location || null,
      budget_range: values.budget_range || null,
      selected_decortype: values.selected_decortype || [],
      Decor_Message: values.Decor_Message || null,
    };

    const dataForSheet = [
      {
        Name: values.Name,
        Email: values.Email,
        Mobile: values.Mobile,
        selected_option: values.selected_option,
        picked: values.picked,
        Rental_Date: values.Rental_Date || null,
        Duration: values.Duration || null,
        product_renting: values.product_renting || null,
        Rental_Message: values.Rental_Message || null,
        Decor_Date: values.Decor_Date || null,
        Event_Location: values.Event_Location || null,
        budget_range: values.budget_range || null,
        selected_decortype: values.selected_decortype || [],
        Decor_Message: values.Decor_Message || null,
      },
    ];

    axios({
      method: "post",
      url: `https://d5jv4obvq9.execute-api.ca-central-1.amazonaws.com/prod/sendEmailService`,
      headers: {
        "content-type": "application/json",
      },
      data: body,
    })
      .then((result) => {
        console.log(result);
        setSuccessMessage("Your request has been submitted successfully!");
        setIsSubmitting(false);
        resetForm(); // Clear the form after successful submission
      })
      .catch((error) => console.log(error));

    fetch(
      `https://script.google.com/macros/s/AKfycbxkJyt3sdLbMYHgE-DbP1w2Mf0ws7A9EbO9DSSzXh9NFoheKE3pFkSD1Wkt__50Absafg/exec`,
      { method: "POST", body: JSON.stringify(dataForSheet) }
    )
      .then((res) => {
        if (res.status === 200) {
          console.log(res);
          setSuccessMessage("Your request has been submitted successfully!");
          setIsSubmitting(false);
          resetForm(); // Clear the form after successful submission
        }
      })
      .catch((error) => console.error("Error!", error.message));
  };
  return (
    <>
      <Formik
        onSubmit={(values, { resetForm }) => {
          handleValidSubmit(values, resetForm);
        }}
        initialValues={{
          Name: "",
          Email: "",
          selected_option: "",
          Mobile: "",
          picked: "",
          Rental_Date: "",
          Duration: "",
          Rental_Message: "",
          product_renting: "",
          Decor_Date: "",
          Event_Location: "",
          budget_range: "",
          selected_decortype: [],
          Decor_Message: "",
        }}
        validationSchema={ContactSchema}
      >
        {({ errors, touched, values }) => (
          <Form
            name="contact-form"
            className="contact-form cons-contact-form p-a30"
          >
            <div className="contact-one">
              {/* TITLE START */}
              <div className="section-head">
                <div className="sx-separator-outer separator-left">
                  <div
                    className="sx-separator  bg-moving bg-repeat-x"
                    style={{ backgroundColor: "#22333B" }}
                  >
                    <h3 className="sep-line-one">Send A Query</h3>
                  </div>
                </div>
              </div>
              {/* TITLE END */}
              <div className="form-group">
                <Field
                  name="Name"
                  className="form-control"
                  placeholder="Full Name"
                />
                <ErrorMessage name="Name">
                  {(msg) => <p className="red">*{msg}</p>}
                </ErrorMessage>
              </div>
              <div className="form-group">
                <Field
                  name="Mobile"
                  className="form-control"
                  type="text"
                  placeholder="Mobile*"
                />
                <ErrorMessage name="Mobile">
                  {(msg) => <p className="red">*{msg}</p>}
                </ErrorMessage>
              </div>
              <div className="form-group">
                <Field
                  name="Email"
                  className="form-control"
                  type="email"
                  placeholder="Email*"
                />
                <ErrorMessage name="Email">
                  {(msg) => <p className="red">*{msg}</p>}
                </ErrorMessage>
              </div>
              <div className="form-group">
                <Field
                  className="form-control"
                  as="select"
                  name="selected_option"
                  placeholder="Choose*"
                >
                  <option value="" disabled>
                    How did you hear about us?
                  </option>
                  <option value="Instagram">Instagram</option>
                  <option value="Google">Google</option>
                  <option value="Facebook">Facebook</option>
                  <option value="Referral">Referral</option>
                </Field>
                <ErrorMessage name="selected_option">
                  {(msg) => <p className="red">*{msg}</p>}
                </ErrorMessage>
              </div>

              <fieldset>
                <div>Rental / Decor Inquiry?</div>
                <hr></hr>
                <label>
                  <Field
                    type="radio"
                    className="mr-1"
                    name="picked"
                    value="Rental"
                  />
                  Rental
                </label>
                <label>
                  <Field
                    type="radio"
                    className="ml-4 mr-1"
                    name="picked"
                    value="Decor"
                  />
                  Decor
                </label>
                <hr></hr>
                {values.picked === "Rental" && (
                  <div>
                    <div className="form-group">
                      <Field
                        name="Rental_Date"
                        className="form-control"
                        type="date"
                        placeholder="Rental Date*"
                      />
                      <ErrorMessage name="Rental_Date">
                        {(msg) => <p className="red">*{msg}</p>}
                      </ErrorMessage>
                    </div>
                    <div className="form-group">
                      <Field
                        name="Duration"
                        className="form-control"
                        type="text"
                        placeholder="Duration*"
                      />
                      <ErrorMessage name="Duration">
                        {(msg) => <p className="red">*{msg}</p>}
                      </ErrorMessage>
                    </div>
                    <div className="form-group">
                      <Field
                        name="product_renting"
                        className="form-control"
                        type="text"
                        placeholder="What are you renting? (Please provide quantity and item name)"
                      />
                      <ErrorMessage name="product_renting">
                        {(msg) => <p className="red">*{msg}</p>}
                      </ErrorMessage>
                    </div>
                    <div className="form-group">
                      <Field
                        name="Rental_Message"
                        className="form-control"
                        as="textarea"
                        rows="4"
                        placeholder="Message*"
                      />
                      <ErrorMessage name="Rental_Message">
                        {(msg) => <p className="red">*{msg}</p>}
                      </ErrorMessage>
                    </div>
                  </div>
                )}
                {values.picked === "Decor" && (
                  <div>
                    <div className="mb-2">
                      Decor Type (Select all that applies):
                    </div>
                    <fieldset className="form-group">
                      <label className="mr-3">
                        <Field
                          type="checkbox"
                          name="selected_decortype"
                          value="Reception"
                          className="mr-1"
                        />
                        Reception
                      </label>
                      <label className="mr-3">
                        <Field
                          type="checkbox"
                          name="selected_decortype"
                          value="Wedding"
                          className="mr-1"
                        />
                        Wedding
                      </label>
                      <label className="mr-3">
                        <Field
                          type="checkbox"
                          name="selected_decortype"
                          value="House_Decor"
                          className="mr-1"
                        />
                        House Decor
                      </label>
                      <label className="mr-3">
                        <Field
                          type="checkbox"
                          name="selected_decortype"
                          value="Pre_wedding_Events"
                          className="mr-1"
                        />
                        Pre-wedding Events
                      </label>
                      <ErrorMessage name="selected_decortype">
                        {(msg) => <p className="red">*{msg}</p>}
                      </ErrorMessage>
                    </fieldset>
                    <hr></hr>
                    <div className="form-group">
                      <Field
                        name="Decor_Date"
                        className="form-control"
                        type="date"
                        placeholder="Event Date*"
                      />
                      <ErrorMessage name="Decor_Date">
                        {(msg) => <p className="red">*{msg}</p>}
                      </ErrorMessage>
                    </div>
                    <div className="form-group">
                      <Field
                        name="Event_Location"
                        className="form-control"
                        type="text"
                        placeholder="Event Location*"
                      />
                      <ErrorMessage name="Event_Location">
                        {(msg) => <p className="red">*{msg}</p>}
                      </ErrorMessage>
                    </div>
                    <div className="form-group">
                      <Field
                        name="budget_range"
                        className="form-control"
                        type="text"
                        placeholder="Budget Range (Total for all events)*"
                      />
                      <ErrorMessage name="budget_range">
                        {(msg) => <p className="red">*{msg}</p>}
                      </ErrorMessage>
                    </div>
                    <div className="form-group">
                      <Field
                        name="Decor_Message"
                        className="form-control"
                        as="textarea"
                        rows="4"
                        placeholder="Message*"
                      />
                      <ErrorMessage name="Decor_Message">
                        {(msg) => <p className="red">*{msg}</p>}
                      </ErrorMessage>
                    </div>
                  </div>
                )}
              </fieldset>
              <div className="text-right">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="site-button btn-half"
                >
                  <span> {isSubmitting ? "Submitting..." : "Submit"} </span>
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      {successMessage && (
        <div className="alert alert-success mt-3">{successMessage}</div>
      )}
      {errorMessage && (
        <div className="alert alert-danger mt-3">{errorMessage}</div>
      )}
    </>
  );
}

export default ContactUsForm;
